
import store from '../store/index'
export const bridge = function () {
  // 获取token信息
  window.getRnInfo = function (info) {
    // alert(JSON.stringify(info))
    const time = new Date().getTime()
    console.log('this is token info', info, 'time1', time)
    store.commit('RnInfo', info)
  }
  // 获取双重认证之后的businesstoken
  window.getHeaders = function (info) {
    console.log('this is token info', info)
    store.commit('headerInfo', info)
  }
  //
  window.isOpenDoubleAuthentication = function (info) {
    console.log('this is token info', info)
    store.commit('isOpen', info)
  }
  // emitRNFunction('goToLogin');   登录失效
  // window.emitRNFunction = function (data, info) {

  // }
}
